<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <!-- Save & Reset Buttons -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0 text-end">
          <v-btn
            class="ma-2"
            elevation="4"
            color="success"
            @click="handleOnNewAddOne"
          >
            <v-icon>mdi-plus-thick</v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            elevation="4"
            color="error"
            @click="handleOnDeleteAddOne"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Table -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-data-table
            :headers="headers"
            item-key="agent_id"
            :items="!isSending ? tableItems : []"
            class="elevation-4 my-agent-table"
            :search="tableSearch"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            show-select
            v-model="tableCBSelected"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    v-model="tableSearch"
                    label="快速搜尋"
                    class="mx-4"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-combobox
                    label="群組"
                    class="mx-4"
                    :items="!isSending ? options2 : []"
                    v-model="optionSelected2"
                  ></v-combobox>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="handleOnEditContact(item)">
                mdi-account-box
              </v-icon>
              <v-icon class="mr-2" @click="handleOnEditAddOne(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <h3>{{ dialogMode ? '新增帳號' : '編輯帳號' }}</h3>
          </v-card-title>
          <!--  -->
          <v-card-text class="pb-0">
            <v-form
              ref="agent-form"
              v-model="dialogInputValid"
              @submit.prevent=""
            >
              <v-text-field
                v-model="username"
                label="帳號"
                :rules="dialogInputRules"
                :counter="40"
                @keydown.space.prevent=""
                required
              ></v-text-field>
              <v-text-field
                v-model="pass"
                label="密碼"
                :counter="20"
                :rules="dialogInputRules"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
                @keydown.space.prevent=""
                required
              ></v-text-field>
              <v-combobox
                label="群組"
                v-model="optionSelected1"
                :items="agentGroupOptions"
                :rules="dialogComboBoxRules"
                required
              ></v-combobox>
              <v-switch
                v-model="userEnb"
                inset
                color="primary"
                :label="`狀態:${userEnb ? '啟用' : '關閉'}`"
              ></v-switch>
            </v-form>
            <v-alert
              v-if="responseStatus.err"
              dense
              outlined
              type="error"
              :icon="responseStatus.err.icon"
              :color="responseStatus.err.color"
            >
              {{ responseStatus.err.text }}
            </v-alert>
          </v-card-text>
          <!--  -->
          <v-card-actions>
            <v-row class="ma-0">
              <v-col>
                <v-btn elevation="4" color="error" @click="dialog = false">
                  <v-icon>mdi-close-thick</v-icon>
                </v-btn>
              </v-col>
              <v-col class="text-end">
                <v-btn
                  elevation="4"
                  color="success"
                  @click="handleOnDialogSave"
                  :disabled="isSending"
                >
                  <v-icon>mdi-check-bold</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <!--  -->
          <v-progress-linear
            :active="isSending"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-card>
      </v-dialog>
      <!-- Dialog Contact -->
      <ContactDialog
        :dialogContact="dialogContact"
        :content="dialogContactContent"
      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ContactDialog from './subComponents1/contactDialog.sc.vue'
export default {
  data: () => ({
    // #region Dialog
    dialog: false,
    dialogInputValid: false,
    dialogMode: true,
    dialogOnSaveFn: undefined,
    dialogInputRules: [
      v => !!v || '不可空白',
      v => v.length <= 30 || '不可超過30個字',
      v => v.length > 5 || '不可少於6個字'
    ],
    dialogComboBoxRules: [
      v => !!v || '不可空白',
      v => typeof v === 'object' || '請選擇現有群組'
    ],
    showPassword: false,
    username: '',
    pass: '',
    userEnb: true,
    // #endregion
    // Combobox
    optionSelected1: '',
    optionSelected2: '',
    // #region Table
    tableSearch: '',
    tableCBSelected: [],
    headers: [
      {
        text: '帳號',
        align: 'start',
        value: 'account'
      },
      {
        text: '姓名',
        align: 'start',
        value: 'name'
      },
      {
        text: '所屬群組',
        align: 'start',
        value: 'text'
      },
      {
        text: '登入時間',
        align: 'start',
        value: 'login_time'
      },
      {
        text: '',
        align: 'start',
        value: 'actions'
      }
    ],
    // #endregion
    // Dialog Contact
    dialogContact: false,
    dialogContactContent: null,
    nothing: undefined
  }),
  components: {
    ContactDialog
  },
  computed: {
    ...mapState('account', ['uid', 'user', 'ad_id']),
    ...mapState('admin', [
      'tableModes',
      'tableMode',
      'isSending',
      'agents',
      'agentGroupOptions',
      'responseStatus'
    ]),
    //
    options2() {
      const o = []
      Object.assign(o, this.agentGroupOptions || [])
      o.unshift({ text: '所有群組', value: 0 })
      return o
    },
    tableItems() {
      const o = []
      if (!this.optionSelected2) return o
      if (this.optionSelected2.value === undefined) return o

      const g_id = this.optionSelected2.value
      if (g_id === 0) return this.agents
      this.agents.forEach(e => {
        if (g_id === e.value) o.push(e)
      })
      return o
    }
  },
  methods: {
    ...mapActions('admin', [
      'getAllAgents',
      'addAgent',
      'updateAgent',
      'deleteAgent'
    ]),
    ...mapMutations('admin', ['resetResponseStatus']),
    //
    handleOnNewAddOne() {
      this.resetResponseStatus()
      this.username = ''
      this.pass = ''
      this.optionSelected1 = ''
      this.userEnb = true

      this.dialogMode = true
      this.dialog = true
      this.$nextTick(() => {
        this.$refs['agent-form'].resetValidation()
      })
      this.dialogOnSaveFn = async () => {
        if (!this.$refs['agent-form'].validate()) return
        // if (!this.username || !this.pass) return
        // if (!this.dialogInputValid) return
        const { username, pass, ad_id, user, uid } = this
        await this.addAgent({
          ad_id,
          user,
          uid,
          username,
          pass,
          g_id: this.optionSelected1.value,
          enb: this.userEnb ? 1 : 0
        })
        if (!this.responseStatus.err) this.dialog = false
      }
    },
    handleOnEditAddOne(item) {
      this.resetResponseStatus()
      this.username = item.account
      this.pass = item.password
      this.optionSelected1 = item.value
        ? { text: item.text, value: item.value }
        : ''
      this.userEnb = item.enb

      this.dialogMode = false
      this.dialog = true
      this.dialogOnSaveFn = async () => {
        if (
          this.username === item.account &&
          this.pass === item.password &&
          this.userEnb === item.enb &&
          this.optionSelected1.value === item.value
        )
          return
        const { username, pass, user, uid } = this
        await this.updateAgent({
          user,
          uid,
          id: item.agent_id,
          username,
          pass,
          g_id: this.optionSelected1.value,
          enb: this.userEnb ? 1 : 0
        })
        if (!this.responseStatus.err) this.dialog = false
      }
    },
    handleOnDeleteAddOne() {
      if (this.tableCBSelected.length < 1) return
      if (!confirm('確定刪除嗎?')) return
      const ids = []
      this.tableCBSelected.forEach(e => {
        ids.push(e.agent_id)
      })
      const { user, uid } = this
      this.deleteAgent({
        user,
        uid,
        ids
      })
    },
    // Dialog
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    },
    // Dialog Contact
    handleOnEditContact(item) {
      this.dialogContact = !this.dialogContact
      this.dialogContactContent = item
      // this.dialogContact = item
    }
  },
  created() {
    this.$emit('setTopLabel', 8)
    //
    ;(async () => {
      const { uid, user } = this
      await this.getAllAgents({ uid, user })
      if (this.options2[0]) this.optionSelected2 = this.options2[0]
    })()
  }
}
</script>

<style lang="scss">
.my-agent-table {
  th,
  td {
    font-size: 18px;
  }

  th {
    white-space: nowrap;
  }

  th:nth-child(3) {
    min-width: 65px;
  }

  th:nth-child(5) {
    min-width: 100px;
  }
}

@media screen and (max-width: 600px) {
  .my-agent-table {
    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }

    th,
    td {
      padding-right: 2px !important;
      padding-left: 4px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
